import { Link } from "react-router-dom";
import SectionLabel from "@/components/SectionLabel";
import { Video, ShieldCheck, ClipboardList, CreditCard } from "lucide-react";

export default function Teleconsultation() {
  return (
    <div>
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <SectionLabel>Teleconsultation</SectionLabel>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900">See the doctor from your home.</h1>
            <p className="mt-4 text-slate-600 leading-relaxed">
              A private video or audio consultation with Dr. Onkar — for follow-ups, minor
              illnesses, prescription refills, and thoughtful medical advice. Digital
              prescription is delivered by WhatsApp or email.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/appointment" className="inline-flex rounded-full px-5 py-3 text-white font-semibold aarogya-shadow"
                    style={{ background: "#0A6EBD" }} data-testid="tele-book-btn">Book Teleconsultation</Link>
            </div>
          </div>
          <div className="rounded-3xl overflow-hidden aarogya-shadow-lg border-4 border-white">
            <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=80" alt="Teleconsultation"
                 className="w-full h-[420px] object-cover" />
          </div>
        </div>
      </section>

      <section className="py-12 lg:py-16" style={{ background: "#F1F6FB" }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { icon: Video, t: "Video / Audio", d: "Choose what suits you and your bandwidth." },
            { icon: ClipboardList, t: "Digital Prescription", d: "Delivered instantly to WhatsApp / email." },
            { icon: ShieldCheck, t: "Private & Secure", d: "Doctor-patient confidentiality respected." },
            { icon: CreditCard, t: "Easy Payment", d: "UPI / cards accepted." },
          ].map((x, i) => (
            <div key={i} className="rounded-2xl bg-white border border-slate-200/70 p-6 aarogya-shadow">
              <x.icon className="h-6 w-6 text-[#0A6EBD]" />
              <div className="mt-3 font-serif text-lg text-slate-900">{x.t}</div>
              <div className="text-sm text-slate-600 mt-1">{x.d}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
